const CognitoConfig = {
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: 'us-east-1:b6cbd52b-5835-4655-bfa7-30506a9e8533', 
    // REQUIRED - Amazon Cognito Region
    region: 'us-east-1', 
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'us-east-1_8oxmmm3uT',
    // OPTIONAL - Amazon Cognito Web Client ID
    userPoolWebClientId: 'vv4rmfsok5kf3ahd3afb6g9k4', 
  }
}

export default CognitoConfig